import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ProgressDialogData } from 'src/app/services/progress-dialog.service';

@Component({
  selector: 'app-progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrls: ['./progress-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProgressDialogComponent {
  i18nParams: { [key: string]: string | number } = this.data.params ?? {};
  constructor(@Inject(MAT_DIALOG_DATA) public data: ProgressDialogData) {}
}
